// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iybr-compensation-table .global-id-actions {
  display: flex;
  align-items: center;
}
.iybr-compensation-table .input-field {
  width: 100px;
  text-align: center;
}
.iybr-compensation-table .input-field.validation-error {
  border: red solid 1px;
  background: rgba(255, 0, 0, 0.1);
}
.iybr-compensation-table .justification-dropdown {
  width: 200px;
}
.iybr-compensation-table .VueTables__row > td:nth-child(4), .iybr-compensation-table th:nth-child(4) {
  border-left: 2px solid #DFDFDF !important;
}
.iybr-compensation-table .VueTables__row > td:nth-child(7), .iybr-compensation-table th:nth-child(7) {
  border-left: 2px solid #DFDFDF !important;
}
.iybr-compensation-table .VueTables__row > td:nth-child(10), .iybr-compensation-table th:nth-child(10) {
  border-left: 2px solid #DFDFDF !important;
}
.iybr-compensation-table .VueTables__row > td:nth-child(12), .iybr-compensation-table th:nth-child(12) {
  border-right: 3px solid #DFDFDF !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
